import React from "react";
import { Routes, Route } from "react-router-dom";
import ListResaleProperties from "../Components/Properties Resale/listResaleProperties";
import ListInterestedPropertyResale from "../Components/Properties Resale/listInterestedPropertyResale";
import HeaderResaleProperty from "../Components/Properties Resale/headerResaleProperty";
import ViewResaleProperties from "../Components/Properties Resale/viewPropertyResale";
// import EditProperties from "../Components/Properties/editProperties";

const PropertiesResaleRoutes = () => {
  return (
    <Routes>
      <Route
        path="/properties_types"
        element={<HeaderResaleProperty></HeaderResaleProperty>}
      ></Route>
      <Route
        path="/properties_types/list"
        element={<ListResaleProperties></ListResaleProperties>}
      ></Route>
      <Route
        path="/properties_types/interested_list"
        element={<ListInterestedPropertyResale></ListInterestedPropertyResale>}
      ></Route>
      <Route
        path="/properties_types/view/:id"
        element={<ViewResaleProperties></ViewResaleProperties>}
      ></Route>
      {/* <Route
        path="/manage_properties/edit/:id"
        element={<EditProperties></EditProperties>}
      ></Route> */}
    </Routes>
  );
};

export default PropertiesResaleRoutes;
